import React from 'react';
import theme from './PromiseCheckList.module.scss';
import { SendProgress, PromiseCheckListItemProps } from '.';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCheckCircle, faTimesCircle, faMinus } from '@fortawesome/pro-light-svg-icons';

const PromiseCheckListItem: React.FC<PromiseCheckListItemProps> = ({ progress, text }) => {
    const renderIcon = () => {
        switch (progress) {
            case SendProgress.NotStarted:
                return <FontAwesomeIcon icon={faMinus} className={theme.notStarted} />;
            case SendProgress.InProgress:
                return <FontAwesomeIcon icon={faSpinner} spin className={theme.inProgress} />;
            case SendProgress.Success:
                return <FontAwesomeIcon icon={faCheckCircle} className={theme.success} />;
            case SendProgress.Failed:
                return <FontAwesomeIcon icon={faTimesCircle} className={theme.error} />;
        }
    };

    return (
        <div className={theme.item}>
            {renderIcon()}
            {text}
        </div>
    );
};

export default PromiseCheckListItem;
